module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/msci1-313f2fda9f178cf2dde897304c2c6ce3.jpg";